/* eslint-disable no-unused-vars */
import styled, { keyframes } from "styled-components";

export const fadeIn = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;

export const fadeOut = keyframes`
from { 
   opacity: 1;
      }
to { 
   opacity: 0;
  }
`;

export const smooth = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;

export const smoothOut = keyframes`
0% {
  opacity: 1;
}
100% {
  opacity: 0;
}
`;
